import { useState, useEffect, useCallback } from 'react';
import { trackPromise } from 'react-promise-tracker';
import caAPI from '../services/caAPI';

export function useDownloadAudio() {
  const [configDownloadAudio, setConfigDownloadAudio] = useState(null);
  const [isDownloading, setIsDownloading] = useState(false);
  
  useEffect(() => {
    trackPromise(
      caAPI.permissoes.verificarDownloadAudio()
        .then((response) => {
          setConfigDownloadAudio(response?.data?.baixar_audio === true);
        })
        .catch((error) => {
          console.error('Erro ao verificar permissão de download de áudio:', error);
          setConfigDownloadAudio(false);
        })
    );
  }, []);
  
  const downloadBlob = useCallback((blob) => {
    try {
      const timestamp = new Date().getTime();
      const nomeArquivo = `arquivo_${timestamp}`;
      const blobUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = nomeArquivo;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(blobUrl);
      document.body.removeChild(a);
    } catch (error) {
      console.error('Erro ao fazer download do arquivo:', error);
      throw error;
    }
  }, []);
  
  const downloadBase64Audio = useCallback(async (base64Data, mimeType = 'audio/wav') => {
    try {
      setIsDownloading(true);
      const link = document.createElement('a');
      link.href = base64Data;
      const timestamp = new Date().getTime();
      const extension = mimeType ? mimeType.split('/')[1] : 'wav';
      link.download = `audio_${timestamp}.${extension}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Erro ao fazer download do áudio base64:', error);
      throw error;
    } finally {
      setIsDownloading(false);
    }
  }, []);
  
  const downloadAudio = useCallback(async (url) => {
    try {
      setIsDownloading(true);
      return trackPromise(
        caAPI.arquivoAtendimento.downloadArquivoPrivado(url, true)
          .then((response) => {
            downloadBlob(response.data);
          })
          .catch((error) => {
            console.error('Erro ao baixar áudio WhatsApp:', error);
            throw error;
          })
      );
    } finally {
      setIsDownloading(false);
    }
  }, [downloadBlob]);

  return {
    configDownloadAudio,
    isDownloading,
    downloadAudio,
    downloadBase64Audio,
    downloadBlob
  };
}

